import { useEffect } from "react"
import { useMutation, useQuery } from "@tanstack/react-query"
import * as notificationsApi from "@/api/notifications"
import { queryClient } from "@/lib/query-client"
import { useNotificationStore } from "@/stores/notification-store"

export function useNotifications() {
  const setUnreadCount = useNotificationStore((state) => state.setUnreadCount)

  const query = useQuery({
    queryKey: ["notifications"],
    queryFn: () => notificationsApi.getNotifications(),
  })

  const notifications = query.data?.data

  useEffect(() => {
    if (notifications) {
      const unread = notifications.filter((n) => !n.read_at).length
      setUnreadCount(unread)
    }
  }, [notifications, setUnreadCount])

  return query
}

export function useMarkAsRead() {
  return useMutation({
    mutationFn: notificationsApi.markAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] })
    },
  })
}

export function useMarkAllAsRead() {
  return useMutation({
    mutationFn: notificationsApi.markAllAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] })
    },
  })
}

export function useNotificationPreferences() {
  return useQuery({
    queryKey: ["notification-preferences"],
    queryFn: notificationsApi.getNotificationPreferences,
  })
}

export function useUpdateNotificationPreferences() {
  return useMutation({
    mutationFn: notificationsApi.updateNotificationPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notification-preferences"] })
    },
  })
}
